window.addEventListener('load', function() {
    // Remove background from Gravity dropdown input
    const gravityDropdown = document.querySelectorAll('.chosen-search-input');
    gravityDropdown.forEach((dropdown) => {
        dropdown.setAttribute('style', 'background-image: none !important');
    });

    // Variables
    const eventsFilterHeader = document.querySelector('.tribe-events-header--has-event-search');
    const eventsPageTitle = document.querySelector('.tribe-events-pro__section-title');
    // Add Title
    if (eventsPageTitle) {
        const cloneTitle = eventsPageTitle.cloneNode(true);
        cloneTitle.classList.add('tribe-events-pro__section-title-mobile');
        eventsFilterHeader.appendChild(cloneTitle);
    }

    // Disable preferred locations on certain fields, depending on location selected
    // Using jQuery as it's much less code and we're including jQuery in the site.
    // (function($) {
    //     $('.preferred-location select').each(function() {
    //         // On load, disable options that are already selected
    //         $('.preferred-location select').not(this).find('option[value="' + this.value + '"]').prop('disabled', true);
    //     });
    //     $('.preferred-location select').on('change', function() {
    //         // enable any previously disabled options
    //         $('.preferred-location option[disabled]').prop('disabled', false);
    //         $('.preferred-location select').each(function() {
    //             // for every other select, disable option which matches this this.value
    //             $('.preferred-location select').not(this).find('option[value="' + this.value + '"]').prop('disabled', true);
    //         });
    //     });
    // })(jQuery);
});
